import React, { useContext, useState } from "react";

// Styling
import "../../Styles/MainPage.scss";

//Material UI stuff
import NotificationsIcon from "@material-ui/icons/Notifications";
import IconButton from "@material-ui/core/IconButton";
import Popover from "@material-ui/core/Popover";
import Tooltip from "@material-ui/core/Tooltip";

// Global state
import { StateContext } from "../../AppStateContext";

const NavbarNotification = () => {
  // Consuming global state
  const state = useContext(StateContext);

  //pop over state
  const [notificationPopOver, setNotificationPopOver] = useState(null);

  const iconStyle = {
    color: "#7285a7",
  };

  //to handle opening and closing notifications popover
  const openNotificationPopOver = (event) => {
    setNotificationPopOver(event.currentTarget);
  };

  const closeNotificationPopOver = () => {
    setNotificationPopOver(null);
  };

  //notification anchorEl
  const open = Boolean(notificationPopOver);

  return (
    <>
      <IconButton onClick={openNotificationPopOver}>
        <Tooltip title="Notifications">
          <NotificationsIcon fontSize="inherit" style={iconStyle} />
        </Tooltip>
      </IconButton>
      <Popover
        disableScrollLock
        id="notificationPopOver"
        open={open}
        anchorEl={notificationPopOver}
        onClose={closeNotificationPopOver}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <p
          style={{
            color: state.theme === "dark" ? "#fff" : "#00152b",
            padding: "3px 20px",
            background: state.theme === "dark" ? "#122742" : "#fff",
            fontFamily: "Alegreya Sans, sans-serif",
          }}
        >
          You have 0 notifications
        </p>
      </Popover>
    </>
  );
};

export default NavbarNotification;
